import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ROUTE_ERROR, ROUTE_REGISTER } from '../constants/Routes';
import useSearchParams from './useSearchParams';
import { PARAM_NAMES } from '../constants/Checkout';
import { analyticsPush } from '../actions/applicationActions';
import { EVT_SHOW_ERROR } from '../constants/EventTypes';
import { useHistory, matchPath, useLocation } from 'react-router';

const bedrockKnownReasons = [
	'subscription_management_requested',
	'no_subscription',
	'logout_requested',
	'registration_requested',
];

export function useHandleRedirectReason() {
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const { getSearchParam } = useSearchParams();
	const { BEDROCK_REDIRECT_REASON } = PARAM_NAMES;
	const bedrockRedirectReasonQueryParam = getSearchParam(BEDROCK_REDIRECT_REASON);
	const isOnRegisterPage = !!matchPath(location.pathname, ROUTE_REGISTER);

	useEffect(() => {
		if (!bedrockRedirectReasonQueryParam) return;

		if (bedrockRedirectReasonQueryParam === 'registration_requested' && !isOnRegisterPage) {
			history.replace(ROUTE_REGISTER);
			return;
		}

		if (!bedrockKnownReasons.includes(bedrockRedirectReasonQueryParam)) {
			dispatch(
				analyticsPush({
					events: {
						category: 'error',
						action: 'redirect_reason',
						label: bedrockRedirectReasonQueryParam,
					},
					event: EVT_SHOW_ERROR,
				})
			);
			history.replace(ROUTE_ERROR);
		}
	}, [bedrockRedirectReasonQueryParam, dispatch, history, isOnRegisterPage]);
}
